<template>
  <ion-header :translucent="true">
    <ion-toolbar>
      <ion-buttons slot="secondary">
        <ion-button @click="closeModal">
          <ion-icon slot="icon-only" :icon="closeOutline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>{{ title }}</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-button id="copylink" @click="share('copy')"  color="light" expand="block">
            <ion-icon style="font-size: 44px; color:rgba(140,140,140,1.0);" :icon="link" ></ion-icon> 
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button @click="share('email')"  color="light" expand="block">
            <ion-icon style="font-size: 44px; color:rgba(140,140,140,1.0);" :icon="mail" ></ion-icon> 
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button @click="share('gettr')"  color="light" expand="block">
            <img src="/assets/gettr.png" > 
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button @click="share('gab')"  color="light" expand="block">
            <img src="/assets/gab.png" > 
          </ion-button>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-button @click="share('truthsocial')"  color="light" expand="block">
            <img src="/assets/truthsocial.png">
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button @click="share('telegram')"  color="light" expand="block">
            <img src="/assets/telegram.png">
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button @click="share('facebook')"  color="light" expand="block">
            <ion-icon style="font-size: 44px; color:rgba(140,140,140,1.0);" :icon="logoFacebook" ></ion-icon> 
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button @click="share('twitter')"  color="light" expand="block">
            <ion-icon style="font-size: 44px; color:rgba(140,140,140,1.0);" :icon="logoTwitter" ></ion-icon> 
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-content>

</template>

<script>
import { IonContent, IonHeader, IonTitle, IonToolbar, IonButton, IonButtons,  modalController, IonIcon, IonGrid, IonRow, IonCol, alertController, isPlatform } from '@ionic/vue';
import { closeOutline, logoFacebook, logoTwitter, logoLinkedin, logoWhatsapp, mail, link  } from 'ionicons/icons';
import { defineComponent } from 'vue';
import getEnv from '@/utils/env'
import { Browser } from '@capacitor/browser';

export default defineComponent({
  name: 'ShareOtherModal',
  props: {
    title: { type: String, default: '' },
    image: { type: Object, default: null },
    story: { type: Object, default: null },
    groupId: { type: Number, default: 0 },
    username:  { type: String, default: '' },
  },
  setup() {
    const isDisabled = false;
    const closeModal = () => {
      modalController.dismiss();
    };

    return {
      closeOutline,
      closeModal,
      isDisabled,
      logoFacebook,
      logoTwitter,
      logoLinkedin,
      logoWhatsapp,
      mail,
      link
    }
  },
  components: { IonContent, IonHeader, IonButton, IonButtons, IonTitle, IonToolbar, IonIcon, IonGrid, IonRow, IonCol },
  methods: {
    async share(type){
      var link = '';
      var linkEncode = encodeURI(this.postLink);
      if(type=='facebook'){
        link = 'https://www.facebook.com/sharer.php?u=' + linkEncode;
        await Browser.open({ url: link });
        //window.open(link, '_blank');
      }else if(type=='twitter'){
        link = 'https://twitter.com/intent/tweet?url=' + linkEncode;
        await Browser.open({ url: link });
        //window.open(link, '_blank');
      }else if(type=='linkedin'){
        link = 'https://www.linkedin.com/shareArticle?mini=true&url=' + linkEncode;
        await Browser.open({ url: link });
        //window.open(link, '_blank');
      }else if(type=='whatsapp'){
        link = "whatsapp://send?text=" + this.postLink;
        window.open(link, '_blank');
      }else if(type=='gettr'){
        link = "https://gettr.com/share?url=" + this.postLink;
        await Browser.open({ url: link });
        //window.open(link, '_blank');
      }else if(type=='gab'){
        link = "https://gab.com/compose?url=" + this.postLink;
        await Browser.open({ url: link });
        //window.open(link, '_blank');
      }else if(type=="telegram"){
        link = "https://t.me/share/url?url=" + this.postLink;
        await Browser.open({ url: link });
        //window.open(link, '_blank');
      }else if(type=="truthsocial"){
        link = "https://truthsocial.com/";
        await Browser.open({ url: link });
        //link = "https://truthsocial.com/share?url=" + this.postLink;
        //window.open(link, '_blank');
      }else if(type=='email'){
        var subject = '';
        var body = '';
        if(this.image!=null){
          subject = this.$t('alertmessage.emailsharestory') + getEnv('APP_NAME');
          body = this.image.description + ' ' + this.postLink;
          window.open('mailto:?subject='+subject+'&body='+encodeURIComponent(this.stripHtml(body)), '_blank');
        }else if(this.username!=null){
          subject = this.$t('alertmessage.emailshareuser') + getEnv('APP_NAME');
          body =this.$t('alertmessage.emailshareuser') + getEnv('APP_NAME') + ': ' + this.postLink;
          window.open('mailto:?subject='+subject+'&body='+encodeURIComponent(this.stripHtml(body)), '_blank');
        }

      }else if(type=='copy'){
        await navigator.clipboard.writeText(this.postLink);
        const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: this.$t('alerthead.copylink'),
          message: this.$t('alertmessage.copylink'),
          buttons: [
            {
              text:  this.$t('buttons.close'),
              role: 'cancel',
              cssClass: 'secondary',
              handler: blah => {
                console.log('Confirm Cancel:', blah)
              },
            },
          ],
        });
        await alert.present();
      }

      console.log('shared');
    },
    stripHtml(html) {
      // Create a new div element
      let temporalDivEl = document.createElement("div");
      // Set HTML content using provider
      temporalDivEl.innerHTML = html;
      // Get the text property of the element (browser support)
      return temporalDivEl.textContent || temporalDivEl.innerText || "";
    }
  },
  data() {
    return {
      path: getEnv('AWS_URL') + getEnv('PHOTO_BUCKET'),
      profilepath: getEnv('AWS_URL') + getEnv('PHOTO_BUCKET') + '/profile/',
      postLink: '' // onmount go ahead and get the link returned
    }
  },
  async mounted() {
    if(this.story!=null && this.image!=null){
      let response = await this.$store.dispatch("helpers/shareLink",{
        story_id: this.story.piklist_id,
        id: this.image.id
      });
      if(response['error']!=undefined){
        console.log('Error: ' + response['error']);
      }else{
        if (isPlatform('hybrid') || isPlatform('electron')) {
          this.postLink = 'https://' + getEnv('SHARE_HOSTNAME') + response.data.url;
        }else{
          this.postLink = 'https://' + window.location.hostname + response.data.url;
        }
      }
    }else if(this.groupId!=0){
      if (isPlatform('hybrid') || isPlatform('electron')) {
        this.postLink = 'https://' + getEnv('SHARE_HOSTNAME') + '/group/' + this.groupId;
      } else {
        this.postLink = 'https://' + window.location.hostname + '/group/' + this.groupId;
      }
       
    }else{
        if (isPlatform('hybrid') || isPlatform('electron')) {
          this.postLink = 'https://' + getEnv('SHARE_HOSTNAME') + '/u/' + this.username;
        }else{
          this.postLink = 'https://' + window.location.hostname + '/u/' + this.username;
        }
    }

  },

});
</script>
